const BREAKPOINTS = [
  { name: 'xs', min: 0, color: '#FBD5D6' },
  { name: 'sm', min: 480, color: '#FFD5A8' },
  { name: 'md', min: 768, color: '#FCE96A' },
  { name: 'lg', min: 1280, color: '#A7D9FC' },
  { name: 'xl', min: 1536, color: '#D1A5FF' },
  { name: '2xl', min: 1920, color: '#FCE8F3' },
];

function createIndicator() {
  const indicator = document.createElement('div');

  indicator.className = 'indicator';
  indicator.innerHTML = `
      <button class="close-btn" aria-label="Close">×</button>
      <div class="breakpoint-name"></div>
      <div class="breakpoint-width"></div>
    `;

  const styles = document.createElement('style');

  styles.textContent = `
      .indicator {
        position: fixed;
        top: 46px;
        right: 0px;
        width: 120px;
        color: #1f2937;
        padding: 4px 16px 4px 8px;
        border-radius: 3px;
        font-family: monospace;
        font-size: 11px;
        text-align: left;
        z-index: 999;
        pointer-events: auto;
        display: none;
      }

      .indicator .breakpoint-name {
        font-weight: bold;
        margin-bottom: 2px;
        font-size: 12px;
      }

      .indicator .breakpoint-width {
        font-size: 9px;
      }

      .indicator .close-btn {
        position: absolute;
        top: 4px;
        right: 4px;
        background: none;
        border: none;
        color: #6b7280;
        font-size: 16px;
        line-height: 1;
        cursor: pointer;
        padding: 0 4px;
        transition: opacity 0.2s;
      }

      .indicator .close-btn:hover {
        opacity: 1;
      }

    `;

  document.head.appendChild(styles);
  document.body.appendChild(indicator);

  return {
    indicator,
    name: indicator.querySelector('.breakpoint-name'),
    width: indicator.querySelector('.breakpoint-width'),
    closeBtn: indicator.querySelector('.close-btn'),
  };
}

function getBreakpoint(width) {
  for (let i = BREAKPOINTS.length - 1; i >= 0; i--) {
    if (width >= BREAKPOINTS[i].min) {
      const bp = BREAKPOINTS[i];

      return {
        name: bp.min > 0 ? `${bp.name} > ${bp.min}px` : bp.name,
        color: bp.color,
      };
    }
  }

  return BREAKPOINTS[0];
}

function update(elements) {
  const width = window.innerWidth;
  const bp = getBreakpoint(width);

  elements.name.textContent = bp.name;
  elements.width.textContent = `current: ${width}px`;
  elements.indicator.style.backgroundColor = bp.color;
}

function init() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);

    return;
  }

  const elements = createIndicator();
  let timeout;
  let isHidden = true;

  elements.closeBtn.addEventListener('click', () => {
    elements.indicator.style.display = 'none';
    isHidden = true;
  });

  window.addEventListener('resize', () => {
    if (isHidden) {
      elements.indicator.style.display = 'block';
      isHidden = false;
    }
    clearTimeout(timeout);
    timeout = setTimeout(() => update(elements), 100);
  });
}

init();
